import { ContentsCountProps } from 'components/FirstTimeExperienceModal/steps/BrandPlanAwareness/Types'
import { FieldArray, useField } from 'formik'
import { ContentCount, getLabel } from 'components/FirstTimeExperienceModal/steps/BrandPlanAwareness/ContentsCount'
import { HTMLAttributes } from 'react'

interface FilteredContentsCountProps extends ContentsCountProps, HTMLAttributes<HTMLDivElement> {
  customLabel?: string
  customCount?: number
  includeTypes?: string[]
  excludeTypes?: string[]
}

export const FilteredContentsCount = ({
  name,
  label,
  icon,
  isDisabled = false,
  customLabel,
  customCount,
  buttonVariant,
  weekLabel = 'week',
  isFullyGreyedOut = false,
  includeTypes,
  excludeTypes,
}: FilteredContentsCountProps) => {
  const [field] = useField<[{ type: string; count: number }]>(name)

  return (
    <FieldArray name={field.name}>
      {({ replace }) => {
        // Filter items based on includeTypes or excludeTypes
        const filteredItems = field.value.filter((item) => {
          if (includeTypes) {
            return includeTypes.includes(item.type)
          }
          if (excludeTypes) {
            return !excludeTypes.includes(item.type)
          }
          return true
        })

        return (
          <>
            {filteredItems.map((value) => {
              const originalIndex = field.value.findIndex((item) => item.type === value.type)
              const displayValue = customCount !== undefined && isDisabled ? customCount : value.count

              return (
                <ContentCount
                  key={value.type}
                  label={getLabel(value.type, customLabel, label)}
                  icon={icon}
                  name={field.name}
                  value={displayValue}
                  onChange={(newValue) => replace(originalIndex, { ...value, count: newValue })}
                  isDisabled={isDisabled}
                  buttonVariant={buttonVariant}
                  weekLabel={weekLabel}
                  isFullyGreyedOut={isFullyGreyedOut}
                />
              )
            })}
          </>
        )
      }}
    </FieldArray>
  )
}
